export default __webpack_public_path__ + "static/media/1.8cb08b41.jpg";